var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_telegram",
    transform: "translate(2189 20913)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11977",
    "data-name": "Rectangle 11977",
    width: 36,
    height: 36,
    transform: "translate(-2189 -20913)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32295",
    "data-name": "Path 32295",
    d: "M56.979,82.252,50.2,80.044s-.81-.329-.549-1.073c.054-.154.162-.284.486-.509,1.5-1.046,27.786-10.494,27.786-10.494a2.239,2.239,0,0,1,1.18-.084.64.64,0,0,1,.436.475,2.165,2.165,0,0,1,.059.6c0,.174-.023.335-.039.588-.16,2.583-4.951,21.86-4.951,21.86s-.287,1.128-1.314,1.167a1.881,1.881,0,0,1-1.371-.53c-2.015-1.733-8.981-6.414-10.52-7.444a.294.294,0,0,1-.126-.208c-.022-.108.1-.243.1-.243S73.506,73.367,73.829,72.235c.025-.088-.069-.131-.2-.093-.806.3-14.77,9.115-16.311,10.088a.743.743,0,0,1-.342.021Z",
    transform: "translate(-2236 -20976)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTelegram);
export default __webpack_public_path__ + "static/media/icon_telegram.ae23ca5da5957016785d214a94cb0bb6.svg";
export { ForwardRef as ReactComponent };